import * as React from 'react';

import classNames from 'classnames';

interface ICardProps {
	className?: string;
	isEqualHeight?: boolean;
	isClosed?: boolean;
}

export default class Card extends React.Component<ICardProps, {}> {
	public render() {
		const { className, isEqualHeight, isClosed } = this.props;

		const classes = classNames(
			'card',
			className && className,
			isEqualHeight && 'is-equal-height',
			isClosed && 'is-closed'
		);

		return <div className={classes}>{this.props.children}</div>;
	}
}
